import { render, staticRenderFns } from "./ConfigReport.vue?vue&type=template&id=03906c89&"
import script from "./ConfigReport.vue?vue&type=script&lang=js&"
export * from "./ConfigReport.vue?vue&type=script&lang=js&"
import style0 from "./ConfigReport.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports